
import React, { useEffect, useState } from "react";
import {
    Autocomplete,
    TextField,
    Chip,
    Box,
    CircularProgress
} from "@mui/material";

export default function CategorySelector({ value, onChange }) {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        const controller = new AbortController();

        async function loadCategories() {
            try {
                const response = await fetch("/api/categories.php", {
                    credentials: "include",
                    signal: controller.signal
                });

                if (!response.ok) {
                    throw new Error("Kategorien konnten nicht geladen werden.");
                }

                const data = await response.json();

                if (!Array.isArray(data)) {
                    throw new Error("Ungültige Kategorien.");
                }

                setCategories(data);
            } catch (err) {
                if (err.name !== "AbortError") {
                    setError(err.message);
                }
            } finally {
                if (!controller.signal.aborted) {
                    setLoading(false);
                }
            }
        }

        loadCategories();

        return () => controller.abort();
    }, []);

    const selectedCategories = categories.filter(
        category => value.includes(category.id)
    );

    return (
        <Autocomplete
            multiple
            options={categories}
            value={selectedCategories}
            loading={loading}
            disabled={loading || !!error}
            getOptionLabel={(option) => option.name}
            isOptionEqualToValue={(option, selected) =>
                option.id === selected.id
            }
            onChange={(_, newValue) => {
                onChange(newValue.map(category => category.id));
            }}
            noOptionsText="Keine Kategorien vorhanden"
            renderOption={(props, option) => {
                const { key, ...otherProps } = props;

                return (
                    <li key={key} {...otherProps}>
                        <Box
                            sx={{
                                width: 14,
                                height: 14,
                                borderRadius: "4px",
                                backgroundColor: option.color,
                                mr: 1.5
                            }}
                        />
                        {option.name}
                    </li>
                );
            }}
            renderTags={(selected, getTagProps) =>
                selected.map((category, index) => {
                    const { key, ...tagProps } = getTagProps({ index });

                    return (
                        <Chip
                            key={key}
                            {...tagProps}
                            label={category.name}
                            size="small"
                            sx={{
                                backgroundColor: category.color,
                                color: "#fff"
                            }}
                        />
                    );
                })
            }
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Kategorien"
                    placeholder="Kategorie auswählen"
                    error={!!error}
                    helperText={error || "Wähle eine oder mehrere Kategorien."}
                />
            )}
        />
    );
}
